import React from 'react';

const Sidebar = ({ activePage, setActivePage, isOpen, toggleSidebar }) => {
  const [expandedSettings, setExpandedSettings] = React.useState(false);
  const [expandedPayments, setExpandedPayments] = React.useState(false);

  const menuItems = [
    {
      id: 1,
      name: 'الرئيسية',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 2,
      name: 'إدارة الحسابات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 2.5,
      name: 'إدارة الطلبات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 2.7,
      name: 'إدارة المدفوعات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      subItems: [
        { name: 'إدارة المدفوعات' },
        { name: 'إعدادات طرق الدفع' }
      ]
    },
    {
      id: 2.8,
      name: 'اختبار التحميل',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 3,
      name: 'التصنيفات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 4,
      name: 'التقارير والإحصائيات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 5,
      name: 'المحتوى',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 6,
      name: 'الإشعارات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )
    },
    {
      id: 7,
      name: 'الإعدادات',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      subItems: [
        { name: 'الإعدادات العامة' },
        { name: 'سياسة الخصوصية' },
        { name: 'شروط الاستخدام' },
        { name: 'حول التطبيق' }
      ]
    },
  ];

  const logoutItem = {
    id: 8,
    name: 'تسجيل خروج',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  };

  return (
    <>
      <aside style={{
        position: 'relative',
        right: 0,
        top: 0,
        width: isOpen ? '245px' : '0',
        height: '100vh',
        backgroundColor: '#2C303A',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1000,
        padding: '0',
        boxSizing: 'border-box',
        transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: isOpen ? '-8px 0 24px rgba(0, 0, 0, 0.2)' : 'none',
        direction: 'rtl',
        overflow: 'hidden',
        flexShrink: 0
      }}>
        {/* Logo Section */}
        <div style={{
          width: '100%',
          minWidth: '245px',
          padding: '28px 20px',
          display: isOpen ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid rgba(249, 245, 240, 0.15)',
          position: 'relative',
          backgroundColor: 'rgba(233, 106, 58, 0.05)'
        }}>
          {/* Logo - Smaller */}
          <img
            src="/Group 1000019470.png"
            alt="Logo"
            style={{
              width: '65px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.1))'
            }}
          />
        </div>

        {/* Main Menu Items Container */}
        <div style={{
          display: isOpen ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          flex: 1,
          overflowY: 'auto',
          paddingRight: '0',
          paddingTop: '24px',
          minWidth: '245px'
        }}>
          {/* Menu Items */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'stretch',
            gap: '8px',
            padding: '0 16px',
            width: '100%'
          }}>
            {menuItems.map((item) => {
              const isActive = activePage === item.name || (item.subItems && item.subItems.some(sub => activePage === sub.name));
              const isSettings = item.id === 7;
              const isPayments = item.id === 2.7;
              const isExpandable = item.subItems && (isSettings || isPayments);
              const isExpanded = isSettings ? expandedSettings : (isPayments ? expandedPayments : false);
              const setExpanded = isSettings ? setExpandedSettings : (isPayments ? setExpandedPayments : () => { });

              return (
                <div key={item.id}>
                  <button
                    onClick={() => {
                      if (isExpandable) {
                        setExpanded(!isExpanded);
                      } else {
                        setActivePage(item.name);
                        if (window.innerWidth < 768) {
                          toggleSidebar();
                        }
                      }
                    }}
                    style={{
                      width: '100%',
                      height: '48px',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      padding: '8px 16px',
                      gap: '10px',
                      borderRadius: '12px',
                      backgroundColor: isActive ? '#F88B8B' : 'transparent',
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      boxSizing: 'border-box'
                    }}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'rgba(249, 245, 240, 0.05)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    {/* Icon - First (Right side in RTL) */}
                    <div style={{
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#FFFFFF',
                      flexShrink: 0
                    }}>
                      {item.icon}
                    </div>

                    {/* Text - After icon */}
                    <span style={{
                      fontFamily: 'El Messiri, sans-serif',
                      fontSize: '14px',
                      fontWeight: isActive ? 700 : 500,
                      lineHeight: '21.88px',
                      color: '#FFFFFF',
                      whiteSpace: 'nowrap',
                      margin: 0,
                      flex: 1,
                      textAlign: 'right'
                    }}>
                      {item.name}
                    </span>

                    {/* Expand/Collapse Icon */}
                    {isExpandable && (
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#FFFFFF',
                          transition: 'transform 0.2s',
                          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </div>
                    )}
                  </button>

                  {/* Sub Items */}
                  {isExpandable && isExpanded && (
                    <div style={{
                      paddingRight: '32px',
                      marginTop: '4px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px'
                    }}>
                      {item.subItems.map((subItem, index) => {
                        const isSubActive = activePage === subItem.name || (subItem.name === 'الإعدادات العامة' && activePage === 'الإعدادات');
                        return (
                          <button
                            key={index}
                            onClick={() => {
                              if (subItem.name === 'إدارة المدفوعات' && isPayments) {
                                setActivePage('إدارة المدفوعات');
                              } else if (subItem.name === 'إعدادات طرق الدفع' && isPayments) {
                                setActivePage('إعدادات طرق الدفع');
                              } else if (subItem.name === 'الإعدادات العامة') {
                                setActivePage('الإعدادات');
                              } else {
                                setActivePage(subItem.name);
                              }
                              if (window.innerWidth < 768) {
                                toggleSidebar();
                              }
                            }}
                            style={{
                              width: '100%',
                              height: '40px',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              padding: '8px 16px',
                              gap: '10px',
                              borderRadius: '8px',
                              backgroundColor: isSubActive ? 'rgba(248, 139, 139, 0.3)' : 'transparent',
                              border: 'none',
                              cursor: 'pointer',
                              transition: 'all 0.2s',
                              boxSizing: 'border-box'
                            }}
                            onMouseEnter={(e) => {
                              if (!isSubActive) {
                                e.currentTarget.style.backgroundColor = 'rgba(249, 245, 240, 0.05)';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSubActive) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }
                            }}
                          >
                            <span style={{
                              fontFamily: 'Cairo, sans-serif',
                              fontSize: '13px',
                              fontWeight: isSubActive ? 600 : 500,
                              lineHeight: '21.88px',
                              color: '#FFFFFF',
                              whiteSpace: 'nowrap',
                              margin: 0
                            }}>
                              {subItem.name}
                            </span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Divider Line */}
          <div style={{
            width: '100%',
            height: '1px',
            backgroundColor: 'rgba(249, 245, 240, 0.22)',
            margin: '8px 0'
          }}></div>
        </div>

        {/* Logout Button - Fixed at bottom */}
        <div style={{
          display: isOpen ? 'flex' : 'none',
          flexDirection: 'column',
          alignSelf: 'stretch',
          padding: '0 16px 20px 16px',
          minWidth: '245px'
        }}>
          <button
            onClick={() => {
              setActivePage('تسجيل خروج');
              if (window.innerWidth < 768) {
                toggleSidebar();
              }
            }}
            style={{
              width: '100%',
              height: '48px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              padding: '8px 16px',
              gap: '10px',
              borderRadius: '12px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxSizing: 'border-box'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(249, 245, 240, 0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {/* Icon - First */}
            <div style={{
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#F9F5F0',
              flexShrink: 0
            }}>
              {logoutItem.icon}
            </div>

            {/* Text - After icon */}
            <span style={{
              fontFamily: 'El Messiri, sans-serif',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '21.88px',
              color: '#F9F5F0',
              whiteSpace: 'nowrap',
              margin: 0
            }}>
              {logoutItem.name}
            </span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
